import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "d-flex justify-center my-5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_page_title = _resolveComponent("page-title")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_page_title, { value: "サインアップ" }),
    _createVNode(_component_v_container, {
      fluid: "",
      class: "pt-8"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_form, null, {
          default: _withCtx(() => [
            _createElementVNode("div", null, [
              _cache[4] || (_cache[4] = _createElementVNode("p", { class: "body-2 blue-grey--text" }, "姓", -1)),
              _createVNode(_component_v_text_field, {
                modelValue: _ctx.postMeRequest.firstName,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.postMeRequest.firstName) = $event)),
                variant: "outlined",
                density: "compact"
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", null, [
              _cache[5] || (_cache[5] = _createElementVNode("p", { class: "body-2 blue-grey--text" }, "名前", -1)),
              _createVNode(_component_v_text_field, {
                modelValue: _ctx.postMeRequest.lastName,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.postMeRequest.lastName) = $event)),
                variant: "outlined",
                density: "compact"
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", null, [
              _cache[6] || (_cache[6] = _createElementVNode("p", { class: "body-2 blue-grey--text" }, "姓カナ", -1)),
              _createVNode(_component_v_text_field, {
                modelValue: _ctx.postMeRequest.firstNameKana,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.postMeRequest.firstNameKana) = $event)),
                variant: "outlined",
                density: "compact"
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", null, [
              _cache[7] || (_cache[7] = _createElementVNode("p", { class: "body-2 blue-grey--text" }, "名前カナ", -1)),
              _createVNode(_component_v_text_field, {
                modelValue: _ctx.postMeRequest.lastNameKana,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.postMeRequest.lastNameKana) = $event)),
                variant: "outlined",
                density: "compact"
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_1, [
              _createVNode(_component_v_btn, {
                onClick: _ctx.postMe,
                color: "primary",
                block: "",
                variant: "flat"
              }, {
                default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                  _createTextVNode(" 送信 ", -1)
                ]))]),
                _: 1
              }, 8, ["onClick"])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}